import styled from "styled-components";
import { Colors } from "../../../constants";

export const PageSubtitle = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: ${Colors.White};
  opacity: 0.8;
`;
